export default class GenericService {

  public static replaceMessage(msg: string[]): string[] {
    const regex = /ORA-\d+:\s*([^\n]+)/;
    const cleanMessage = msg
      .map((message: string) => {
        const match = regex.exec(message);
        const cleanedMessage = match ? match[1].trim() : message;
        return cleanedMessage.replace(/#@#@"?$/g, '');
      });
    return cleanMessage;
  }
}
